import { UPDATE_GIFTING_BNBL_MODAL, INITIALISE_BNBL_MODAL, UPDATE_BNBL_NUMBER_OF_ROOMS, UPDATE_BNBL_PACKAGE_VIEW } from './actionConstants'
import { AppAction } from './types/ActionTypes'
import { BnblRoomPackage } from './types/offerActionTypes'

export function updateBnblGifting(offerId: string, isGift: boolean): AppAction {
  return {
    type: UPDATE_GIFTING_BNBL_MODAL,
    offerId,
    isGift,
  }
}

export function initialiseBnblOfferModal(
  packages: Array<BnblRoomPackage>,
  offerId: string,
  isGift: boolean,
): AppAction {
  return {
    type: INITIALISE_BNBL_MODAL,
    packages,
    offerId,
    isGift,
  }
}

export function updateBnblNumberOfRooms(numberOfRooms: number, offerId: string, packageUniqueKey: string): AppAction {
  return {
    type: UPDATE_BNBL_NUMBER_OF_ROOMS,
    numberOfRooms,
    offerId,
    packageUniqueKey,
  }
}

export function updateBnblPackageView(offerId: string, packageView: App.OfferPackageOptionView): AppAction {
  return {
    type: UPDATE_BNBL_PACKAGE_VIEW,
    offerId,
    packageView,
  }
}
